<template>
    <el-dialog class="recommend-resume-dialog"  :title="getTitle()" :visible.sync="showDialog">
        <div
            v-if="isSingle"
            class="content-confirm border-radius" :key="preventKey"
        >
            <h1 class="text-center">候选人信息</h1>
            <el-row>
                <el-col>
                    <p>
                        <span>候选人：{{ confirmInfo.name }}</span>
                        <span class="ml-20">性别：{{ getSelectMapText('WB_GENDER', confirmInfo.gender) || '-'}}</span>
                        <span class="ml-20">手机号：{{ confirmInfo.phone }}</span>
                        <span class="ml-20">邮箱：{{ confirmInfo.email }}</span>
                    </p>
                    <p class="mt-10">当前职位：{{ confirmInfo.position }}<span class="ml-20">最高学历学校：{{ confirmInfo.school }}</span><span v-if="confirmInfo.sLevel">【{{confirmInfo.sLevel}}】</span></p>
                </el-col>
            </el-row>
        </div>
        <div
            v-else
            class="content-confirm-multiple"
        >
            <h1>已勾选<span>{{ selectedCount }}</span>条记录</h1>
        </div>
        <el-form is="el-form" :model="ruleForm" :rules="rules" ref="ruleForm" :key="preventKey" class="form-beauty"
                   label-width="150px">
            <el-form-item label="定级" prop="secLevel">
                <el-select size="medium" v-model="ruleForm.secLevel" placeholder="请选择" @change="changeLevel" style="width: 300px;display: inline-block">
                    <el-option
                        v-for="(option,index) in paymentConf.list"
                        :key="index"
                        :label="option.secLevel"
                        :value="option.secLevel"
                    ></el-option>
                </el-select>
                <span v-if="paymentConf.preUrl" class="ml-20"><a :href="paymentConf.preUrl" target="_blank">查看定级说明</a></span>
            </el-form-item>
            <el-form-item label="定薪" prop="paymentLevel">
                <el-select size="medium" v-model="ruleForm.paymentLevel" placeholder="请选择" style="width: 300px;display: inline-block">
                    <el-option
                            v-for="(option, index) in sStructureList"
                            :key="index"
                            :label="option.paymentLevel"
                            :value="option.paymentLevel"
                    >
                    </el-option>
                </el-select>
                <span v-if="paymentInfo" class="ml-20">offer标准：{{paymentMonth}}</span>
            </el-form-item>
            <el-form-item label="备注">
                <el-input  type="textarea" :row="2" v-model="ruleForm.remark" placeholder="请输入内容" :maxlength="1000"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="showDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import fetchPositionListMixin from './fetchPositionListMixin'
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'
    export default {
        mixins: [fetchPositionListMixin, selectMapMixin, formCommonMixin],
        data () {
            return {
                showDialog: false,
                isSingle: true,
                confirmInfo: {
                    name: '',
                    gender: '',
                    phone: '',
                    email: '',
                    position: '',
                    school: ''
                },
                sSchoolLevelList: [],
                sStructureList: [],
                sLevelList: [],
                selectedCount: 0,
                preventKey: 1,
                ruleForm: {
                    resumePositionId: null,
                    resumePositionIdList: null,
                    paymentLevel: null,
                    remark: '',
                    secLevel: null
                },
                paymentConf: {},
                rules: {
                    paymentLevel: {required: true, message: '请输入定薪结构', trigger: 'change'},
                    secLevel: {required: true, message: '请输入定薪级别', trigger: 'change'},
                    interviewersEvaluate: {required: true, message: '请输入面试官综合评价', trigger: 'blur,change'}
                }
            }
        },
        computed: {
            paymentInfo () {
                let obj = null
                console.log(this.paymentConf.list)
                if (this.paymentConf && this.ruleForm.paymentLevel && this.paymentConf.list) {
                    this.paymentConf.list.forEach(item => {
                        if (item.secLevel === this.ruleForm.secLevel) {
                            item.paymentList.forEach(one => {
                                if (one.paymentLevel === this.ruleForm.paymentLevel) {
                                    obj = one
                                }
                            })
                        }
                    })
                }
                return obj
            },
            paymentMonth () {
                return this.paymentInfo ? this.paymentInfo.paymentMonth : 0
            },
            paymentTotal () {
                return this.paymentInfo ? this.paymentInfo.paymentTotal : 0
            }
        },
        methods: {
            changeLevel (data) {
                if (this.paymentConf.list) {
                    this.paymentConf.list.forEach(item => {
                        if (item.secLevel === data) {
                            this.sStructureList = item.paymentList
                        }
                    })
                    this.ruleForm.paymentLevel = ''
                }
            },
            initData () {
                // this.sSchoolLevelList = this.getSalaryMap('WB_SCHOOL_LEVEL')
                // this.sStructureList = this.getSalaryMap('WB_SAlAEY_STRUCTURE')
                // this.sLevelList = this.getSalaryMap('WB_SAlAEY_LEVEL')
            },
            getTitle() {
                return this.isSingle ? '定薪修改' : '定薪批量修改'
            },
            show (data, single = true) {
                console.log(data)
                this.preventKey = +new Date()
                this.isSingle = single
                this.initData()
                if (this.isSingle) {
                    this.confirmInfo = {
                        name: data.resumeForm.name,
                        gender: data.resumeForm.gender,
                        phone: data.resumeForm.mobilePhone,
                        email: data.resumeForm.email,
                        position: data.positionForm.name,
                        school: data.resumeForm.resumeMaxEducation.school,
                        sLevel: data.resumeForm.resumeMaxEducation.sLevel
                    }
                    for (let key in this.ruleForm) {
                        this.ruleForm[key] = data.resumePayment[key]
                    }
                    this.ruleForm.resumePositionId = data.id
                } else {
                    this.selectedCount = data.length
                    this.ruleForm.resumePositionIdList = data.map(item => item.id).join(',')
                }
                this.$axios.post('/payment/queryTemplateByPositionId.api', {
                    id: this.isSingle ? data.positionForm.id : data[0].positionForm.id
                }).then(res => {
                    this.paymentConf = res.result
                    if (this.ruleForm.secLevel) {
                        let paymentLevel = this.ruleForm.paymentLevel
                        this.changeLevel(this.ruleForm.secLevel)
                        this.ruleForm.paymentLevel = paymentLevel
                    }
                    this.showDialog = true
                })
            },
            saveForm () {
                let url = this.isSingle ? '/payment/updateEva.api' : '/payment/batchUpdateEva.api'
                this.$axios.post(url, Object.assign({}, this.ruleForm, {
                    paymentTotal: this.paymentTotal,
                    paymentMonth: this.paymentMonth
                }), {'X-showMessage': true}).then(res => {
                    this.showDialog = false
                    this.$emit('reload')
                }).catch(console.error)
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .recommend-resume-dialog {
    .content-confirm {
        background-color : $color-primary;
        color            : white;
        margin           : 0 20px 20px;
    > h1 {
        font-size : 18px;
        padding   : 15px;
    }
    > .el-row {
        background-color : #59a0ff;
        padding          : 15px;
        border-radius    : 0 0 $border-radius $border-radius;
    }
    }
    .content-confirm-multiple {
        margin: 0 0 20px 100px;
        span {
            font-weight: bold;
        }
    }
    }
</style>



// WEBPACK FOOTER //
// modifySalaryDialog.vue?471381a2